import { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { Header } from "../../components/Header";
import { HeaderCategories } from "../../components/HeaderCategories";
import { Menu } from "../../components/Menu";
import { useLocation } from "react-router-dom";
import CopyToClipboard from "react-copy-to-clipboard";
import IconesNovos from "../../components/NewIcones/IconesNovos";

import NoImg from "../../assets/images/no-image.png";

import { QuantityButton } from "../../components/QuantityButton";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { floatToPrice, isNumber } from "../../functions/price_functions";
import { MainButton } from "../../components/MainButton";
import { useOrder } from "../../hooks/useOrder";
import InputMask from "react-input-mask";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";
import api from "../../services/api";

import "./index.css";
import { cepNoMask } from "../../functions/mask";
import Swal from "sweetalert2";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useToast } from "../../hooks/useToast";
import { ModalImage } from "../../components/ModalImage";
import { OrderType } from "../../contexts/OrderContext";
import { ProductType, VariationType } from "../../contexts/ProductsContext";
import { useProduct } from "../../hooks/useProduct";
import { useQuery } from "../../hooks/useQuery";
import { ModalProdutoCarrinho } from "../../components/ModalProdutoCarrinho/index";
import { DiscountFlag } from "../../components/DiscountFlag";
import { ButtonProduct } from "../../components/buttonProduct/ButtonProduct";
import { useFaceBookPixel } from "../../hooks/useFacebookPixel";
type MultipleVariationTypes = {
  name: string;
  values: string[];
};

type CommentType = {
  id: string;
  comment: string;
  name: string;
};

type InterestType = {
  id: string;
  name: string;
  img: string | null;
};

type InterestResponseType = {
  code: string;
  customerId: string;
  description: string;
  imgsuffix: string;
  name: string;
  path: string;
  pluginspaceId: string;
  productId: string;
  typeimg: string;
};

type StoresType = {
  id: number;
  name: string;
  currentBalance: number;
  distance: string;
};

type ImageType = {
  typeimg: string;
  path: string;
  imgsuffix: string;
  order: number;
};

type AddressLocationType = {
  cep: string;
  city: string;
  district: string;
  extra: string;
  number: string;
  state: string;
  street: string;
};

type LocationType = {
  id: number;
  name: string;
  code: string;
  status: boolean;
  type: string;
  cep: string;
  address: AddressLocationType | null;
};

type VariationImageType = {
  image: string;
  sku: string;
  order: number;
};

export function Product() {
  const { pluginspace_id, product_id } = useParams();
  const { trackAddToCart } = useFaceBookPixel();
  const navigate = useNavigate();
  const { pushToOrder, getOrder, changeCustomerAdress } = useOrder();
  const { getToken, getThisPluginspace, registerAccess, getLocations } =
    usePluginspace();
  const [locations, setLocations] = useState<Array<LocationType>>([]);
  const { productSelected } = useProduct();
  const query = useQuery();
  const orderContext = useOrder();
  const [searchParams, setSearchParams] = useSearchParams();
  const [showFlag, setShowFlag] = useState(true);
  const [openDetails, setOpenDetails] = useState(true);
  const [openFreight, setOpenFreight] = useState(false);
  const [openOpinions, setOpenOpinions] = useState(false);
  const [openGuide, setOpenGuide] = useState(true);

  const [cep, setCep] = useState("");
  const [cepAlarm, setCepAlarm] = useState(false);
  const [findCep, setFindCep] = useState(false);
  const [valueCep, setValueCep] = useState(0);
  const [showMoreStores, setShowMoreStores] = useState(false);

  const [quantity, setQuantity] = useState(1);

  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);

  const [product, setProduct] = useState<ProductType | null>(null);
  const [subcategoryName, setSubcategoryName] = useState("");
  const [variations, setVariations] = useState<Array<MultipleVariationTypes>>(
    []
  );

  const [selectedVariation, setSelectedVariation] = useState<any>({});
  const [price, setPrice] = useState(0);
  const [minorPrice, setMinorPrice] = useState(0);
  const [promotionalPrice, setPromotionalPrice] = useState(0);
  const [stock, setStock] = useState(0);
  const [img, setImg] = useState("");
  const [sku, setSku] = useState("");

  const [comments, setComments] = useState<Array<CommentType>>([]);
  const [interests, setInterests] = useState<Array<InterestType>>([]);
  const [stores, setStores] = useState<Array<StoresType>>([]);
  const [selectedImg, setSelectedImg] = useState(0);
  const [variationImages, setVariationImages] = useState<
    Array<VariationImageType>
  >([]);
  const [variationImagesNow, setVariationImagesNow] = useState<
    Array<VariationImageType>
  >([]);

  const [modalImage, setModalImage] = useState(false);
  const [urlImageOpen, setUrlImageOpen] = useState("");
  const [orderFinded, setOrderFinded] = useState<OrderType | null>(null);
  const [pluginspaceData, setPluginspaceData] = useState<any>();

  const [myOrdenationVariation, setMyOrdenationVariation] = useState([
    "PP",
    "XS",
    "P",
    "S",
    "M",
    "G",
    "L",
    "2G",
    "GG",
    "LL",
    "XL",
    "3G",
    "3L",
    "XXL",
    "XGG",
    "1X",
    "2X",
    "3X",
    "3L",
    "4X",
    "4L",
    "0-3 meses",
    "3-6 meses",
    "6-9 meses",
    "9-12 meses",
    "PP/P",
    "P/M",
    "M/G",
    "G/GG",
    "GG/G1",
    "G1/G2",
    "G2/G3"
  ]);

  const [loadingImage, setLoadingImage] = useState(true);
  const [loadingHeader, setLoadingHeader] = useState(true);

  const [modalOpen, setModalOpen] = useState(false);
  const [productModal, setProductModal] = useState<any | null>(null);

  const [imgGuide, setImgGuide] = useState<string | null>(null);

  // Estados para os ícones
  const [animate, setAnimate] = useState(false);
  const [animateHeart, setAnimateHeart] = useState(false);
  const [favoriteProduct, setFavoriteProduct] = useState(false);
  const location = useLocation();

  const [grandPrice, setGrandPrice] = useState(0);
  const [minimunPrice, setMinimunPrice] = useState(0);

  const [goToLastImagem, setGoToLastImagem] = useState(0);

  const { openToast } = useToast();

  async function createVendorCart() {
    if (
      query.get("vendor") !== undefined &&
      query.get("vendor") !== "" &&
      query.get("vendor") != null
    ) {
      // gerar um carrinho informando qual o vendedor

      const x = query.get("vendor");

      const vendedorCPF = atob(x!);

      orderContext.cpfVendorByLink(vendedorCPF);
      orderContext.setSellerCpfCnpj(vendedorCPF);
      orderContext.setShouldUpdadeCustomerCart(true);

      registerAccess(
        "product",
        vendedorCPF,
        parseInt(product_id!),
        window.location.pathname
      );

      searchParams.delete("vendor");

      setSearchParams(searchParams);
    } else {
      registerAccess("product");
    }
  }

  useEffect(() => {
    createVendorCart();
    getConfig();
  }, []);

  useEffect(() => {
    getAllInfos();
  }, [product_id]);

  async function saveInfoSellerLinkCart() {
    if (orderContext.shouldUpdadeCart) {
      const orderToStorage = Object.assign(orderContext);
      await orderToStorage.encryptOrderStorage(orderToStorage);
    }
  }
  useEffect(() => {
    saveInfoSellerLinkCart();
  }, [orderContext.shouldUpdadeCart]);
  async function getAllInfos() {
    setLoading(true);
    await getOrderSaved();
    await getProduct();
    const loc = await getLocations();

    setLocations(loc);
    // await getComments();
    // await getInterest();
    setLoading(false);
  }

  async function getOrderSaved() {
    const newOrder = await getOrder();
    setPluginspaceData(await getThisPluginspace());
    setOrderFinded(newOrder);
  }

  async function getStores() {
    const noMaskCep = cepNoMask(cep);
    await api
      .post(
        `api/variations/skuzipcode`,
        {
          zipcode: noMaskCep,
          skus: [sku],
          noVerifyStock:
            config && config.content.pdv.showOutStock ? true : false,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        const newStores: Array<StoresType> = response.data.map(
          (str: StoresType) => {
            return {
              id: str.id,
              name: str.name,
              distance: str.distance,
              currentBalance: str.currentBalance,
            };
          }
        );
        setStores(newStores);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getInterest() {
    await api
      .post(
        `api/interest`,
        {
          productId: product_id,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        await api
          .post(
            `api/interest/ranking`,
            {
              limitRank: 10,
            },
            {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            }
          )
          .then(async (response) => {
            const allInterests: Array<InterestType> = response.data.data.map(
              (interest: InterestResponseType) => {
                let img = "";
                if (interest.path !== null) {
                  img = interest.imgsuffix + "/" + interest.path;
                } else {
                  img = interest.imgsuffix;
                }
                const objInterest: InterestType = {
                  id: interest.productId,
                  name: interest.name,
                  img: img,
                };
                return objInterest;
              }
            );
            const filterInterest = allInterests.filter(
              (interest) => interest.id !== product_id
            );
            setInterests(filterInterest);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getComments() {
    await api
      .post(
        `api/comments/filter`,
        {
          productId: product_id,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        const responseComments = response.data.data.map((comment: any) => {
          return {
            id: comment.id,
            comment: comment.comment,
            name: comment.customer[0].name,
          };
        });
        setComments(responseComments);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getProduct() {
    if (productSelected && false) {
      // fitProduct(productSelected);
      // let minimumPrice = Number.MAX_VALUE;
      // let minimumVariation: any;
      // productSelected.variations.forEach((vrt) => {
      //   if (vrt.price < minimumPrice) {
      //     minimumPrice = vrt.price;
      //     minimumVariation = vrt;
      //   }
      // });
      // const pricePreview = minimumVariation
      //   ? minimumVariation.price
      //   : productSelected.variations[0].price;
      // setPrice(pricePreview);
      // // com o novo campo de disconto do catalogo, agora todos os produtos que vierem do catalogo e tiver um desconto
      // // deve ser calculado.
      // let promotionalPricePreview = minimumVariation
      //   ? minimumVariation.promotionalPrice
      //   : productSelected.variations[0].promotionalPrice;
      // const promotionalPriceCalculated = calculateDiscountFromParam(
      //   pricePreview,
      //   promotionalPricePreview
      // );
      // setPromotionalPrice(promotionalPriceCalculated);
      // setMinorPrice(
      //   minimumVariation
      //     ? minimumVariation.price
      //     : productSelected.variations[0].price
      // );
      // setStock(productSelected.variations[0].inventory);
      // await fitVariations(productSelected.variations);
      // setImg(productSelected.variations[0].img);
      // const variationFromImages: Array<VariationImageType> = [];
      // productSelected.images
      //   .sort((a, b) => b.typeimg.length - a.typeimg.length)
      //   .forEach((image: ImageType) => {
      //     if (image.typeimg === "image" || image.typeimg === "imgsmall") {
      //       let imgProduct =
      //         image.path.split("://")[1] === "s3.amazonaws.com/img.ninegrid.com"
      //           ? image.imgsuffix.includes("s3.amazonaws.com/img.ninegrid.com")
      //             ? image.imgsuffix
      //             : image.path + "/" + image.imgsuffix
      //           : image.path;
      //       if (
      //         imgProduct &&
      //         variationFromImages &&
      //         variationFromImages.findIndex(
      //           (imgVariation) => imgVariation.image === imgProduct
      //         ) === -1
      //       ) {
      //         variationFromImages.push({
      //           sku: "",
      //           image: imgProduct,
      //         });
      //       }
      //     }
      //   });
      // setVariationImagesNow(
      //   variationFromImages.filter(
      //     (variationImage) =>
      //       variationImage.image.split("://")[1] !==
      //       "s3.amazonaws.com/img.ninegrid.com/"
      //   )
      // );
      // productSelected.variations.forEach((variation: VariationType) => {
      //   if (variation.img && variationFromImages) {
      //     variationFromImages.push({
      //       sku: variation.sku,
      //       image: variation.img,
      //     });
      //   }
      // });
      // setVariationImages(
      //   variationFromImages.filter(
      //     (variationImage) =>
      //       variationImage.image.split("://")[1] !==
      //       "s3.amazonaws.com/img.ninegrid.com/"
      //   )
      // );
      // setSubcategoryName(
      //   productSelected.classification
      //     ? productSelected.classification.name
      //     : ""
      // );
    } else {
      await api
        .get(`api/product/${product_id}`, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then(async (response) => {
          fitProduct(response.data.data[0]);
          let minimumPrice = Number.MAX_VALUE;
          let maximumPrice = Number.MIN_VALUE;
          let minimumVariation: any;
          let maximumVariation: any;
          response.data.data[0].variations.forEach((vrt: VariationType) => {
            if (vrt.price < minimumPrice) {
              minimumPrice = vrt.price;
              minimumVariation = vrt;
            }
            if (vrt.price > maximumPrice) {
              maximumPrice = vrt.price;
              maximumVariation = vrt;
            }
          });

          const pricePreview = minimumVariation
            ? minimumVariation.price
            : response.data.data[0].variations[0].price;

          setPrice(pricePreview);
          setMinimunPrice(pricePreview);
          setGrandPrice(
            maximumVariation
              ? maximumVariation.price
              : response.data.data[0].variations[0].price
          );

          // com o novo campo de disconto do catalogo, agora todos os produtos que vierem do catalogo e tiver um desconto
          // deve ser calculado.
          let promotionalPricePreview = minimumVariation
            ? minimumVariation.promotionalPrice
            : response.data.data[0].variations[0].promotionalPrice;

          const promotionalPriceCalculated = calculateDiscountFromParam(
            pricePreview,
            promotionalPricePreview
          );

          setPromotionalPrice(promotionalPriceCalculated);

          setMinorPrice(
            minimumVariation
              ? minimumVariation.price
              : response.data.data[0].variations[0].price
          );
          setStock(response.data.data[0].variations[0].inventory);
          await fitVariations(response.data.data[0].variations);
          setImg(response.data.data[0].variations[0].img);

          const variationFromImages: Array<VariationImageType> = [];

          response.data.data[0].images
            .sort(
              (a: ImageType, b: ImageType) =>
                b.typeimg.length - a.typeimg.length
            )
            .forEach((image: ImageType) => {
              const { typeimg, path, imgsuffix } = image;

              // Processa imagens de produto
              if (typeimg === "image" || typeimg === "mainpicture") {
                const imgProduct = buildImageUrl(path, imgsuffix);

                if (
                  imgProduct &&
                  !isImageAlreadyAdded(variationFromImages, imgProduct)
                ) {
                  variationFromImages.push({
                    sku: "",
                    image: imgProduct,
                    order: image.order,
                  });
                }
              }

              // Processa imagem de guia
              if (typeimg === "guide") {
                const imgGuide = buildImageUrl(path, imgsuffix);
                setImgGuide(imgGuide);
              }
            });

          const imagensOrdenadas = variationFromImages
            .filter(
              (imageVariation) =>
                imageVariation.image.split("://")[1] !==
                "s3.amazonaws.com/img.ninegrid.com/"
            )
            .sort((a, b) => a.order - b.order);
          setVariationImagesNow(imagensOrdenadas);

          response.data.data[0].variations.forEach(
            (variation: VariationType) => {
              if (variation.img && variationFromImages) {
                variationFromImages.push({
                  sku: variation.sku,
                  image: variation.img,
                  order: -1,
                });
              }
            }
          );

          setVariationImages(
            variationFromImages.filter(
              (imageVariation) =>
                imageVariation.image.split("://")[1] !==
                "s3.amazonaws.com/img.ninegrid.com/"
            )
          );
          await api
            .get(
              `api/classification/${response.data.data[0].classificationId}`,
              {
                headers: {
                  Authorization: `Bearer ${await getToken()}`,
                },
              }
            )
            .then(async (responseSubcategory) => {
              setSubcategoryName(responseSubcategory.data.data[0].name);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  function buildImageUrl(path: string, imgsuffix: string): string {
    const isS3Image =
      path.split("://")[1] === "s3.amazonaws.com/img.ninegrid.com";
    return isS3Image ? `${path}/${imgsuffix}` : path;
  }

  function isImageAlreadyAdded(
    variations: VariationImageType[],
    imageUrl: string
  ): boolean {
    return variations.some((variation) => variation.image === imageUrl);
  }

  async function fitVariations(variations: VariationType[]) {
    let varitiationsFormated: MultipleVariationTypes[] = [];
    const conf = await getAppConfig();
    const objVt = JSON.parse(variations[0].context);
    variations.forEach((vrt) => {
      const objVrtNew = JSON.parse(vrt.context);
      Object.entries(objVrtNew).forEach((vrtContext) => {
        if (!Object.keys(objVt).includes(vrtContext[0])) {
          objVt[vrtContext[0]] = vrtContext[1];
        }
      });
    });
    const objSelected: any = {};
    Object.entries(selectedVariation).map((key) => {
      objSelected[key[0]] = key[1];
    });

    Object.keys(objVt).map((key) => {
      let values: string[] = [];
      variations.map((vrt) => {
        const obj = JSON.parse(vrt.context);
        if (
          values &&
          obj[key] &&
          !values.includes(obj[key]) &&
          (vrt.inventory - vrt.minimumStock > 0 ||
            (conf && conf.content.pdv.showOutStock)) &&
          vrt.status
        ) {
          values.push(obj[key]);
        }
      });
      objSelected[key] = values[0];
      if (values.length > 0) {
        varitiationsFormated.push({
          name: key,
          values: values,
        });
      }
    });
    setVariations(varitiationsFormated);
    let objToSelect: any = {};
    varitiationsFormated.forEach((vari) => {
      if (vari.values.length > 0) {
        objToSelect[vari.name] = vari.values[0];
      }
    });
    let skuFinded = "";
    let foundValid = false;
    variations.forEach((vrt) => {
      if (JSON.stringify(objToSelect) === vrt.context) {
        skuFinded = vrt.sku;
        setPrice(vrt.price);
        const newPromotinaolPrice = calculateDiscountFromParam(
          vrt.price,
          vrt.promotionalPrice.toString()
        );
        setPromotionalPrice(newPromotinaolPrice);
        setSku(skuFinded);
        foundValid = true;
      }
    });
    if (foundValid) {
      setSelectedVariation(objToSelect);
    } else {
      setSelectedVariation({});
    }
  }

  function fitProduct(pdt: ProductType) {
    let variationsSkus: string[] = [];
    let variationsFit: VariationType[] = [];
    if (pdt.variations) {
      for (let i = 0; i < pdt.variations.length; i++) {
        // if (!variationsSkus.includes(pdt.variations[i].sku)) {
        variationsSkus.push(pdt.variations[i].sku);
        variationsFit.push(pdt.variations[i]);
        // }
      }
    }
    pdt.variations = variationsFit;
    pdt.variations.map((vt) => {
      if (vt.img && !vt.img.includes("http")) {
        vt.img = `https://s3.amazonaws.com/img.ninegrid.com/${vt.img}`;
      }
    });
    setProduct(pdt);
  }

  async function getConfig() {
    setLoadingHeader(true);
    const config = await getAppConfig();
    const showFlag = config?.content.showFlagDiscount || false;
    setShowFlag(showFlag);
    setConfig(config);
    setLoadingHeader(false);
  }

  function selectVariation(variationName: string, variationValue: string) {
    const objSelected: any = {};
    Object.entries(selectedVariation).map((key) => {
      objSelected[key[0]] = key[1];
    });
    if (objSelected[variationName] === variationValue)
      delete objSelected[variationName];
    else objSelected[variationName] = variationValue;
    setSelectedVariation(objSelected);
    changeVariationSelected(objSelected);
  }

  function changeVariationSelected(objSelected: any) {
    let findedSku = false;
    selectVariationImages(objSelected);
    product?.variations.forEach((vt, index) => {
      const context = JSON.parse(vt.context);
      const sizeTypes = Object.keys(context).length;
      const sizeTypesSent = Object.keys(objSelected).length;
      let sizeComparation = 0;
      Object.keys(context).map((key) => {
        if (context[key] === objSelected[key]) {
          sizeComparation++;
        }
      });
      if (sizeComparation === sizeTypes && sizeTypesSent === sizeTypes) {
        findedSku = true;
        const indexForImage = variationImages.findIndex(
          (variationImg) => variationImg.image === vt.img
        );
        setSelectedImg(indexForImage);
        setPrice(vt.price);
        setStock(vt.inventory);
        const newPromotinaolPrice = calculateDiscountFromParam(
          vt.price,
          vt.promotionalPrice.toString()
        );

        setPromotionalPrice(newPromotinaolPrice);

        setImg(vt.img);
        setSku(vt.sku);
        if (findCep) {
          getStores();
        }
      }
    });
    if (!findedSku) {
      const compatibleVariations = product?.variations.filter(vt => {
        const context = JSON.parse(vt.context);
        return Object.entries(objSelected).every(([key, value]) =>
          context[key] === value
        );
      }) || [];

      if (compatibleVariations.length > 0) {
        // Usa o menor preço das variações compatíveis
        const minCompatiblePrice = Math.min(...compatibleVariations.map(v => v.price));
        setPrice(minCompatiblePrice);

        // Calcula preço promocional se houver
        const compatiblePromo = compatibleVariations.find(v => v.promotionalPrice > 0);
        if (compatiblePromo) {
          const newPromotionalPrice = calculateDiscountFromParam(
            minCompatiblePrice,
            compatiblePromo.promotionalPrice.toString()
          );
          setPromotionalPrice(newPromotionalPrice);
        }
      } else {
        // Fallback para preço mínimo do produto
        setPrice(minimunPrice || minorPrice);
        setPromotionalPrice(0);
      }




      setSelectedImg(0);
      setSku("");
    }
  }

  function changeQuantity(value: number) {
    if (config && config.content.pdv.showOutStock) {
      setQuantity(value > 0 ? value : 0);
    } else {
      const stockOk = verifyMaxStockWithCart(value);
      if (!stockOk) {
        Swal.fire({
          icon: "warning",
          title: "Estoque máximo atingido",
          text: "Não será mais possível aumentar a quantidade do produto",
        });
      } else if (value <= stock) {
        setQuantity(value > 0 ? value : 0);
      } else if (value > stock) {
        Swal.fire({
          icon: "warning",
          title: "Estoque máximo atingido",
          text: "Não será mais possível aumentar a quantidade do produto",
        });
      }
    }
  }

  function verifyMaxStockWithCart(value: number) {
    let stockOk = true;
    if (orderFinded) {
      orderFinded.products.forEach((product) => {
        if (product.quantity + value > stock && product.sku === sku) {
          stockOk = false;
        }
      });
    }
    return stockOk;
  }

  async function verifyMaxStockDatabase(value: number, locationId: number) {
    let stockOk = true;
    let quantityNow = 0;
    if (orderFinded) {
      orderFinded.products.forEach((product) => {
        if (product.sku === sku) {
          quantityNow += product.quantity;
        }
      });
    }
    return await api
      .post(
        `/api/variations/sku`,
        {
          skus: [sku],
          locationId,
          status: true,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => {
        if (
          response.data &&
          response.data.data &&
          response.data.data[0] &&
          response.data.data[0].inventory >= quantityNow + value
        ) {
          return stockOk;
        } else {
          return false;
        }
      })
      .catch((e) => {
        console.log(e);
        return false;
      });
  }

  async function addCart() {
    setLoading(true);
    const findedVariation = product?.variations.find((vari) => {
      if (vari.sku === sku) {
        const qtdSelected = Object.keys(JSON.parse(vari.context)).length;
        let qtdFinded = 0;
        Object.entries(JSON.parse(vari.context)).forEach((itemObject) => {
          if (selectedVariation[itemObject[0]] === itemObject[1]) {
            qtdFinded++;
          }
        });
        return qtdSelected === qtdFinded;
      }
      return false;
    });
    if (!findedVariation) {
      const referenceVariation = product?.variations[0];
      const contextKeys = referenceVariation
        ? Object.keys(JSON.parse(referenceVariation.context))
        : [];

      const selectedKeys = Object.keys(selectedVariation);
      const missing = contextKeys.filter((key) => !selectedKeys.includes(key));

      const readable = missing
        .map((key) => {
          return key.charAt(0).toUpperCase() + key.slice(1);
        })
        .join(", ");

      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text:
          missing.length > 0
            ? `Selecione: ${readable} do produto`
            : "Detalhes incompletos.",
      });

      setLoading(false);
      return;
    }

    let stockOk = false;
    if (config && config.content.pdv.showOutStock) stockOk = true;
    else
      stockOk = await verifyMaxStockDatabase(
        quantity,
        findedVariation?.locationId ? findedVariation.locationId : 0
      );
    setLoading(false);
    if (!stockOk) {
      Swal.fire({
        icon: "warning",
        title: "Estoque máximo atingido",
        text: "Não é possível adicionar mais deste produto",
      });
    } else if (
      product !== null &&
      sku !== "" &&
      findedVariation &&
      (findedVariation.inventory > 0 ||
        (config && config.content.pdv.showOutStock)) &&
      findedVariation.status === true
    ) {
      const imageIfNotHave = variationImages[0] ? variationImages[0].image : "";
      const prod = {
        id: product_id ? parseInt(product_id) : 2,
        name: product.name,
        image: img
          ? img
          : product.img
            ? product.img
            : imageIfNotHave
              ? imageIfNotHave
              : "",
        unitPrice: price,
        promotionalPrice: parseFloat(promotionalPrice.toFixed(2)),
        quantity: quantity,
        stock: stock,
        sku: sku,
        variation: selectedVariation,
        code: product.code,
        locationId: findedVariation.locationId,
        pluginspaceHash: pluginspace_id ? pluginspace_id : "",
        outStock: false,
        measures: {
          width: findedVariation.width ? findedVariation.width : 0,
          height: findedVariation.height ? findedVariation.height : 0,
          lenght: findedVariation.depth ? findedVariation.depth : 0,
          weight: findedVariation.weight ? findedVariation.weight : 0,
        },
      };

      const prodModalCarrinho = {
        id: product_id ? parseInt(product_id) : 2,
        name: product.name,
        image: findedVariation.img
          ? findedVariation.img
          : img
            ? img
            : product.img
              ? product.img
              : imageIfNotHave
                ? imageIfNotHave
                : "",
        unitPrice: price,
        promotionalPrice: parseFloat(promotionalPrice.toFixed(2)),
        quantity: quantity,
        stock: stock,
        sku: sku,
        variation: selectedVariation,
        code: product.code,
        locationId: findedVariation.locationId,
        pluginspaceHash: pluginspace_id ? pluginspace_id : "",
        outStock: false,
        measures: {
          width: findedVariation.width ? findedVariation.width : 0,
          height: findedVariation.height ? findedVariation.height : 0,
          lenght: findedVariation.depth ? findedVariation.depth : 0,
          weight: findedVariation.weight ? findedVariation.weight : 0,
        },
      };

      pushToOrder(prod);
      //navigate(-1);
      const priceToCart = findedVariation.promotionalPrice
        ? findedVariation.promotionalPrice
        : findedVariation.price;
      trackAddToCart(priceToCart * quantity, {
        id: product_id ? parseInt(product_id) : 2,
        name: product?.name || "",
        price: priceToCart,
        quantity: quantity,
        sku: sku,
        category: subcategoryName,
      });
      setProductModal(prodModalCarrinho);
      setModalOpen(true);
      openToast("success", "Produto adicionado ao carrinho com sucesso!");
    } else {
      Swal.fire({
        icon: "warning",
        title: "Produto indisponível",
      });
    }
  }

  async function findCepDelivery() {
    const noMaskCep = cepNoMask(cep);
    setLoading(true);
    let urlSearchValid = "";
    switch (config?.content.pdv.restrictCep) {
      case "cep":
        urlSearchValid = `api/zip-code/valid/${noMaskCep}`;
        break;
      case "area":
        urlSearchValid = `api/delivery/valid/${noMaskCep}`;
        break;
      case "mapa":
        urlSearchValid = `/api/delivery-area/valid/${noMaskCep}`;
        break;
      default:
        urlSearchValid = `api/zip-code/valid/${noMaskCep}`;
        break;
    }
    await api
      .get(urlSearchValid, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        changeCustomerAdress(noMaskCep);
        const findedCeps = response.data.data;
        changeCustomerAdress(noMaskCep);
        if (findedCeps.length > 0 && findedCeps[0].valor >= 0) {
          setFindCep(true);
          setValueCep(findedCeps[0].valor);
          getStores();
        } else {
          setFindCep(false);
          Swal.fire({
            icon: "warning",
            title: "Não disponível",
            text: "CEP não disponível para entrega",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setFindCep(false);
        console.log(err);
        setLoading(false);
      });
  }

  // Função auxiliar para comparar se o contexto de uma variação bate com o selecionado
  function contextMatchesSelected(context: any, selected: any) {
    return Object.entries(selected).every(
      ([key, value]) => context[key] === value
    );
  }

  // Função auxiliar para extrair contextos válidos das variações do produto
  function getValidContexts(
    product: ProductType | null,
    config: any,
    selectedVariation: any
  ) {
    if (!product) return [];
    return product.variations
      .filter(
        (vrt) =>
          (vrt.inventory - vrt.minimumStock > 0 ||
            (config && config.content.pdv.showOutStock)) &&
          vrt.status
      )
      .map((vrt) => JSON.parse(vrt.context))
      .filter((context) => contextMatchesSelected(context, selectedVariation));
  }

  // Função auxiliar para montar as variações válidas a partir dos contextos
  function buildValidatedVariations(contexts: any[]): MultipleVariationTypes[] {
    const variationMap: { [name: string]: Set<string> } = {};
    contexts.forEach((context) => {
      Object.entries(context).forEach(([name, value]) => {
        if (!variationMap[name]) variationMap[name] = new Set();
        variationMap[name].add(value as string);
      });
    });
    return Object.entries(variationMap).map(([name, values]) => ({
      name,
      values: Array.from(values),
    }));
  }

  // Função melhorada validateVariations
  function validateVariations(variationsToValidate: MultipleVariationTypes[]) {
    if (Object.keys(selectedVariation).length === 0) {
      return variationsToValidate;
    }

    // Monta os contextos válidos das variações do produto
    const variationsContext =
      product?.variations
        .filter(
          (vrt) =>
            (vrt.inventory - vrt.minimumStock > 0 ||
              (config && config.content.pdv.showOutStock)) &&
            vrt.status
        )
        .map((vrt) => JSON.parse(vrt.context))
        .filter((context) =>
          Object.entries(selectedVariation).every(
            ([key, value]) => context[key] === value
          )
        ) || [];

    if (variationsContext.length === 0) {
      // Cria uma mensagem mais específica mostrando as variações selecionadas
      const selectedVariationsText = Object.entries(selectedVariation)
        .map(([key, value]) => {
          // Formata o nome da variação para ficar mais legível
          const formattedKey = key === "NOME_COR" ? "cor" : key.toLowerCase();
          return `${formattedKey} ${value}`;
        })
        .join(" e ");

      const message = selectedVariationsText
        ? `A combinação de ${selectedVariationsText} não está disponível`
        : "Combinação inválida";

      Swal.fire({
        icon: "warning",
        title: "Variação indisponível",
        text: message,
        confirmButtonText: "OK",
      });
      setSelectedVariation({});
      return variationsToValidate;
    }

    // Monta as variações válidas a partir dos contextos
    let variationsValidated: MultipleVariationTypes[] = [];
    variationsContext.forEach((context) => {
      Object.entries(context).forEach(([name, value]) => {
        let variation = variationsValidated.find((v) => v.name === name);
        if (!variation) {
          variation = { name, values: [] };
          variationsValidated.push(variation);
        }
        if (!variation.values.includes(value as string)) {
          variation.values.push(value as string);
        }
      });
    });

    // Garante que as opções já selecionadas continuem disponíveis
    variationsValidated = variationsValidated.map((variation) => {
      const original = variationsToValidate.find(
        (v) => v.name === variation.name
      );
      if (original) {
        // Mantém a ordem dos valores originais e adiciona apenas os extras ao final
        const extras = variation.values.filter(
          (val) => !original.values.includes(val)
        );
        const allValues = [...original.values, ...extras];
        return { ...variation, values: allValues };
      }
      return variation;
    });

    return variationsValidated;
  }

  function selectVariationImages(contextVariation: any) {
    let findedSku = "";
    product?.variations.forEach((vt, index) => {
      const context = JSON.parse(vt.context);
      const sizeTypes = Object.keys(context).length;
      const sizeTypesSent = Object.keys(contextVariation).length;
      let sizeComparation = 0;
      Object.keys(context).map((key) => {
        if (context[key] === contextVariation[key]) {
          sizeComparation++;
        }
      });
      if (sizeComparation === sizeTypes && sizeTypes === sizeTypesSent) {
        findedSku = vt.sku;
      }
    });

    const sortImages = variationImages
      .filter((image) => {
        if (image.sku === "") {
          return true;
        } else if (image.sku === findedSku && findedSku !== "") {
          return true;
        } else if (JSON.stringify(selectedVariation).includes("VARIATION")) {
          return true;
        } else {
          return false;
        }
      })
      .sort((a, b) => {
        // Imagens com sku vão para o final
        if (a.sku && a.sku !== "") {
          if (b.sku && b.sku !== "") {
            return a.order - b.order;
          }
          return 1;
        }
        if (b.sku && b.sku !== "") {
          return -1;
        }
        return a.order - b.order;
      });

    // Reset selectedImg quando as imagens mudam para evitar travamento
    setSelectedImg(0);
    setGoToLastImagem(sortImages.length - 1);
    setVariationImagesNow(sortImages);
  }

  function calculateDiscountFromParam(
    originalPrice: number,
    promotionalPrice: string
  ) {
    try {
      const discountValueParam = query.get("discount");

      if (!discountValueParam) {
        return parseFloat(promotionalPrice);
      }

      const discountV = window.atob(discountValueParam);

      const discount = parseFloat(discountV);
      const discountValue = originalPrice * (discount / 100);
      const finalPrice = originalPrice - discountValue;
      return finalPrice;
    } catch (error) {
      return 0;
    }
  }

  // Funções para controlar animações e favoritos
  const handleAnimation = (type: string) => {
    if (type === "heart") {
      setAnimateHeart(true);
      setTimeout(() => setAnimateHeart(false), 1000);
    } else if (type === "share") {
      setAnimate(true);
      setTimeout(() => setAnimate(false), 1000);
    }
  };

  const saveFavorite = () => {
    setFavoriteProduct(!favoriteProduct);
    // Aqui você pode adicionar a lógica para salvar o favorito no localStorage ou API
  };

  return (
    <div className="product-total">
      <div className="content-product">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
            extraSpacingLeftMenu
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <>
            <HeaderCategories
              fontColor={
                config?.webappcolor.fonttitlebar
                  ? config.webappcolor.fonttitlebar
                  : "#FFFFFF"
              }
              backgroundColor={
                config?.webappcolor.backgroundtitlebar
                  ? config.webappcolor.backgroundtitlebar
                  : "#000000"
              }
              categories={[
                product?.name
                  ? product.name.length > 35
                    ? product.name.slice(0, 35).concat(`...`)
                    : product.name
                  : "",
              ]}
              blockViewMode={
                config && config.content.noUseViewMode
                  ? config.content.noUseViewMode
                  : false
              }
              shareContent
            />
            <div className="product-body">
              <div className="product-image relative">
                {promotionalPrice !== 0 &&
                  promotionalPrice !== price &&
                  showFlag ? (
                  <DiscountFlag
                    type={
                      config?.content.flagDiscount
                        ? config?.content.flagDiscount
                        : "trigonal"
                    }
                    color={
                      config?.webappcolor.flagDiscountColor
                        ? config?.webappcolor.flagDiscountColor
                        : "#000"
                    }
                    value={parseInt(
                      (((price - promotionalPrice) / price) * 100).toFixed(2)
                    )}
                    isDetailProductPage
                    isList={false}
                  />
                ) : (
                  <></>
                )}
                <div id="list-images">
                  <Carousel
                    key={`${variationImagesNow
                      .map((img) => img.image)
                      .join(",")}-${Date.now()}`}
                    showThumbs={false}
                    showStatus={false}
                    showArrows={true}
                    selectedItem={goToLastImagem ?? 0} // Sempre começar do primeiro item quando mudar
                    swipeable={true}
                    preventMovementUntilSwipeScrollTolerance={true}
                    swipeScrollTolerance={50}
                  >
                    {variationImagesNow.length === 0
                      ? [
                        <div
                          className={`w-full flex justify-center product-image-carousel`}
                          style={
                            loadingImage
                              ? {
                                visibility: "hidden",
                                width: 0,
                                height: 0,
                              }
                              : {}
                          }
                          onLoad={() => {
                            setLoadingImage(false);
                          }}
                          key={"no-image"}
                          onClick={() => {
                            setModalImage(true);
                            setUrlImageOpen(NoImg);
                          }}
                        >
                          <img
                            src={NoImg}
                            className={`rounded-medium object-contain`}
                            alt="Sem imagem"
                          />
                        </div>,
                      ]
                      : variationImagesNow.map((variationImg) => (
                        <div
                          className={`w-full flex justify-center product-image-carousel`}
                          style={
                            loadingImage
                              ? {
                                visibility: "hidden",
                                width: 0,
                                height: 0,
                              }
                              : {}
                          }
                          onLoad={() => {
                            setLoadingImage(false);
                          }}
                          key={variationImg.image}
                          onClick={() => {
                            setModalImage(true);
                            setUrlImageOpen(variationImg.image || NoImg);
                          }}
                        >
                          <img
                            src={variationImg.image || NoImg}
                            className={`rounded-medium object-contain`}
                            alt={variationImg.image || "Sem imagem"}
                          />
                        </div>
                      ))}
                  </Carousel>
                </div>

                {/* Ícone de Compartilhar */}
                <div className="share-float-btn">
                  <CopyToClipboard
                    text={window.location.origin + location.pathname}
                    onCopy={() => {
                      handleAnimation("share");
                      openToast("success", "Link copiado com sucesso!");
                    }}
                  >
                    <button className={animate ? "pulse-animation" : ""}>
                      <IconesNovos
                        cor={"#222"}
                        active={true}
                        type={"plane"}
                        action={() => { }}
                      />
                    </button>
                  </CopyToClipboard>
                </div>
              </div>
              <div className="product_info_container">
                <div className="product_title">
                  <span className="product_ref">
                    <b>REF:</b>{" "}
                    {product?.code ? product.code : "Código não encontrado"}
                  </span>

                  {config?.content.showProductMark && (
                    <span className="product_mark">
                      <b>Marca:</b> {product?.mark ? product.mark.name : "-/-"}
                    </span>
                  )}

                  <span className="product_model">
                    <b>Modelo:</b> {product?.name}
                  </span>
                </div>

                <div
                  className="product_price"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "center",
                  }}
                >
                  {promotionalPrice !== 0 && promotionalPrice !== price ? (
                    <>
                      <span className="old_price">{floatToPrice(price)}</span>
                      <span className="promotional_price">
                        {floatToPrice(promotionalPrice)}
                      </span>
                    </>
                  ) : (
                    <span className="promotional_price">
                      {floatToPrice(price)}
                    </span>
                  )}
                </div>
              </div>

              {/* {promotionalPrice !== 0 && promotionalPrice !== price ? (
                  <div className="promotional-prices">
                    <p className="old-price" style={{ color: "#00000077" }}>
                      {floatToPrice(price)}
                    </p>
                    <p className="price" style={{ color: "#000" }}>
                      {floatToPrice(promotionalPrice)}
                    </p>
                    <div
                      className="discount-text"
                      style={{
                        backgroundColor: config?.webappcolor.flagDiscountColor
                          ? config?.webappcolor.flagDiscountColor
                          : "#000",
                      }}
                    >
                      <p>
                        <b>
                          -
                          {parseInt(
                            (
                              ((price - promotionalPrice) / price) *
                              100
                            ).toFixed(2)
                          )}
                          %
                        </b>{" "}
                        off
                      </p>
                    </div>
                  </div>
                ) : (
                  <p className="price" style={{ color: "#000" }}>
                    {floatToPrice(price ? price : minorPrice)}
                  </ */}
              {validateVariations(variations)
                .filter((variation, idx, allVariations) => {
                  // Lógica de omissão de grades baseada em OmitGrid
                  if (!config?.content?.pdv?.omitGrid) return true;

                  const variationOne = allVariations.every(
                    (v) => v.values.length === 1
                  );
                  const variationMoreTwo = allVariations.some(
                    (v) => v.values.length >= 3
                  );
                  return !variationOne || variationMoreTwo;
                })
                .map((variation, idx) => {
                  if (
                    variation.name !== "VARIATION" &&
                    variation.values[0] !== "NONE"
                  ) {
                    return (
                      <div
                        className={`product-sizes${idx === 0 ? " first" : ""}`}
                        key={variation.name}
                      >
                        <p>
                          {variation.name === "NOME_COR"
                            ? "COR"
                            : variation.name}
                          : <span>{selectedVariation[variation.name]}</span>
                        </p>
                        {variation.values[0] &&
                          variation.values[0].length > 2 ? (
                          <div className="sizes">
                            {variation.values.sort((a, b) => {
                              // Função para obter a prioridade do item no array myOrdenationVariation
                              const getPriority = (item: string) => {
                                const index = myOrdenationVariation.indexOf(item);
                                return index === -1 ? Number.MAX_SAFE_INTEGER : index;
                              };

                              const priorityA = getPriority(a);
                              const priorityB = getPriority(b);

                              // Se ambos têm prioridade definida, ordena pela prioridade
                              if (priorityA !== Number.MAX_SAFE_INTEGER && priorityB !== Number.MAX_SAFE_INTEGER) {
                                return priorityA - priorityB;
                              }

                              // Se apenas um tem prioridade, ele vem primeiro
                              if (priorityA !== Number.MAX_SAFE_INTEGER) return -1;
                              if (priorityB !== Number.MAX_SAFE_INTEGER) return 1;

                              // Se nenhum tem prioridade, usa ordenação natural (numérica/alfabética)
                              return a.localeCompare(b, undefined, { numeric: true });
                            }).map((s, index) => {
                              return (
                                <button
                                  key={`${s}-${index}`}
                                  className={
                                    s == selectedVariation[variation.name]
                                      ? "retangle-selected"
                                      : "retangle"
                                  }
                                  onClick={() =>
                                    selectVariation(variation.name, s)
                                  }
                                >
                                  <p>
                                    {s}
                                    {index + 1 < variation.values.length}
                                  </p>
                                </button>
                              );
                            })}
                          </div>
                        ) : (
                          <div className="sizes">
                            {variation.values.sort((a, b) => {
                              // Função para obter a prioridade do item no array myOrdenationVariation
                              const getPriority = (item: string) => {
                                const index = myOrdenationVariation.indexOf(item);
                                return index === -1 ? Number.MAX_SAFE_INTEGER : index;
                              };

                              const priorityA = getPriority(a);
                              const priorityB = getPriority(b);

                              // Se ambos têm prioridade definida, ordena pela prioridade
                              if (priorityA !== Number.MAX_SAFE_INTEGER && priorityB !== Number.MAX_SAFE_INTEGER) {
                                return priorityA - priorityB;
                              }

                              // Se apenas um tem prioridade, ele vem primeiro
                              if (priorityA !== Number.MAX_SAFE_INTEGER) return -1;
                              if (priorityB !== Number.MAX_SAFE_INTEGER) return 1;

                              // Se nenhum tem prioridade, usa ordenação natural (numérica/alfabética)
                              return a.localeCompare(b, undefined, { numeric: true });
                            }).map((s, index) => {
                              return (
                                <button
                                  key={`${s}-${index}`}
                                  className={
                                    s == selectedVariation[variation.name]
                                      ? "circle-selected"
                                      : "circle"
                                  }
                                  onClick={() =>
                                    selectVariation(variation.name, s)
                                  }
                                >
                                  <p>{s}</p>
                                </button>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  }
                })}

              {product?.description && (
                <div
                  className="product-option"
                  style={openDetails ? { backgroundColor: "#FFF" } : {}}
                >
                  <div
                    className="hide-item"
                    onClick={() => setOpenDetails(!openDetails)}
                  >
                    <p>Detalhes</p>
                  </div>
                  <div className="details">
                    <p
                      style={openDetails ? {} : { WebkitLineClamp: 4 }}
                      dangerouslySetInnerHTML={
                        product?.description
                          ? { __html: product.description }
                          : undefined
                      }
                    ></p>
                  </div>
                </div>
              )}

              {product?.technicalSpecification && (
                <div
                  className="product-option"
                  style={openDetails ? { backgroundColor: "#FFF" } : {}}
                >
                  <div
                    className="hide-item"
                    onClick={() => setOpenDetails(!openDetails)}
                  >
                    <p>Especificação Técnica</p>
                  </div>
                  <div className="details">
                    <p
                      style={openDetails ? {} : { WebkitLineClamp: 4 }}
                      dangerouslySetInnerHTML={
                        product?.technicalSpecification
                          ? { __html: product.technicalSpecification }
                          : undefined
                      }
                    ></p>
                  </div>
                </div>
              )}

              {imgGuide && (
                <div
                  className="product-option"
                  style={openGuide ? { backgroundColor: "#FFF" } : {}}
                >
                  <div
                    className="hide-item"
                    onClick={() => setOpenGuide(!openGuide)}
                  >
                    <p>Guia de medidas</p>
                  </div>

                  <div
                    className="details-guide"
                    style={{
                      height: "auto",
                      maxHeight: "none",
                      overflow: "visible",
                    }}
                  >
                    {imgGuide ? (
                      <img
                        src={imgGuide}
                        alt="Guia de medidas"
                        style={{
                          width: "100%",
                          height: "auto",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <p>Guia de medidas não disponível</p>
                    )}
                  </div>
                </div>
              )}
              {/* <div className="quantity-product">
                <div className="change-quantity">
                  <QuantityButton
                    changeValue={() => changeQuantity(quantity - 1)}
                  >
                    <svg
                      width="14"
                      height="2"
                      viewBox="0 0 14 2"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="14" height="2" fill="#ABABAB" />
                    </svg>
                  </QuantityButton>
                  <input
                    type="text"
                    onChange={(event) =>
                      changeQuantity(
                        parseInt(event.target.value ? event.target.value : "0")
                      )
                    }
                    value={quantity > 0 ? quantity : ""}
                  />
                  <QuantityButton
                    changeValue={() => changeQuantity(quantity + 1)}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6 0V6H0V8H6V14H8V8H14V6H8V0H6Z"
                        fill="#ABABAB"
                      />
                    </svg>
                  </QuantityButton>
                </div>
                {promotionalPrice !== 0 && promotionalPrice !== price ? (
                  <p className="price">
                    {floatToPrice(promotionalPrice * quantity)}
                  </p>
                ) : (
                  <p className="price">{floatToPrice(price * quantity)}</p>
                )}
              </div> */}
              {(config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales) ||
                quantity <= 0 ? (
                <></>
              ) : (
                <div className="add-cart">
                  <ButtonProduct
                    action={async () => {
                      addCart();
                    }}
                    label={"Comprar"}
                    backgroundColor={
                      config?.webappcolor.webappbutton
                        ? config.webappcolor.webappbutton
                        : "#EAEAEA"
                    }
                    color={
                      config?.webappcolor.fontbutton
                        ? config?.webappcolor.fontbutton
                        : "#636363"
                    }
                    marginBottom
                    price={price}
                    promotionalPrice={promotionalPrice}
                    quantity={quantity}
                    onIncrease={() => changeQuantity(quantity + 1)}
                    onDecrease={() => changeQuantity(quantity - 1)}
                    inputChange={(value) => changeQuantity(value)}
                  />
                </div>
              )}
            </div>
          </>
        )}
        {!loadingHeader && (
          <Menu
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {modalImage && (
          <ModalImage
            isOpen={modalImage}
            setIsOpen={setModalImage}
            urlImage={urlImageOpen}
          />
        )}
      </div>
      <ModalProdutoCarrinho
        isOpen={modalOpen}
        setIsOpen={setModalOpen}
        product={productModal}
      />
    </div>
  );
}
